export default class Transfer {
  /**
   * Create new transfer and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @param {string} value
   */
  set amount (value) {
    this._amount = parseFloat(value)
  }

  /**
   * @return {Int}
   */
  get amount () {
    return this._amount
  }

  /**
   * @return {Date}
   */
  get maturityDate () {
    return this._maturityDate
  }

  /**
   * @param {string} value
   */
  set maturityDate (value) {
    this._maturityDate = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get transferDate () {
    return this._transferDate
  }

  /**
   * @param {string} value
   */
  set transferDate (value) {
    this._transferDate = new Date(value)
  }
}
